export function playNotificationSound() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();

    function tone(freq, start, duration) {
      const osc  = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.type = 'sine';
      osc.frequency.setValueAtTime(freq, start);
      gain.gain.setValueAtTime(0, start);
      gain.gain.linearRampToValueAtTime(0.22, start + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.001, start + duration);
      osc.start(start);
      osc.stop(start + duration);
    }

    // Pleasant two-note chime: C6 → G5
    tone(1047, ctx.currentTime,        0.28);
    tone(784,  ctx.currentTime + 0.18, 0.32);
  } catch {
    // Web Audio unavailable or blocked
  }
}
